<div class="main-page">
    <app-header></app-header>
    <div class="container">
	 <div class="email-verification-top">
	    <div class="email-verification">
        <ngx-ui-loader fgsSize="40" [fgsType]="spinnerType"></ngx-ui-loader>
           <div class="sigup-screen-area">
	 <span class="nav-divnk">Email Verification</span>
	 </div>
            <div class="content-part">
			  <img src="assets/message-2.png">
			</div>

        <div class="row">
            <p (click)="edit()" class="text-deco"><span  [ngStyle]="isEdit == true && { 'color': 'transparent' }">{{userEmail}}</span><span style="margin-left:10px;    vertical-align: middle;
"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span></p>
        </div>
        <form class="row" [formGroup]="form" (ngSubmit)="updateEmail(form.value)" *ngIf="isEdit">
            <div class="row form-update ">
            <div class="form-group enter-email">
                <input type="email" class="form-control" formControlName="email" placeholder="Enter email"  [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Email is required</div>
                    <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                </div>
                </div>
            <button type="submit" class="btn btn-primary mb-2">Update</button>
          </div>

        </form>
        <div class="row">
            <p class="text-deco text-deco-2 ">A verification code has been sent to {{userEmail}} <br> (Check your spam folder)</p>
        </div>

        <div class="row">
            <p class="text-deco">Enter your code here</p>
        </div>
        <form class="email-verification-form"  novalidate>
        <div class="verification-box">
            <ng-otp-input type="number" (onInputChange)="onOtpChange($event)"  [config]="{length:4}"></ng-otp-input>
        </div>
        <div class="row verify-button" style="margin-top: 10px;">
            <button  (click)="verifyEmail()" class="btn btn-primary btn-sm" type="button" >Verify</button>
        </div>
        <div class="row resend-button" style="display: flex; justify-content: center;">
            <p (click)="resendEmail()" class="resendCode">Resend Code</p>
        </div>
        </form>


	      </div>
	   </div>
    </div>




    <div class="footer">
    </div>
    </div>
